import ExportModal, { ExportModalProps } from './ExportModal'
import { COMPANIES_COLUMNS } from 'components/Tables/CompaniesTable/companiesColumnInfo'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'

export default function ContactCompanyExportModal(
  props: ExportModalProps & {
    subCategoryName: string
  }
) {
  const companyColumnHelper = createExportColumnHelper({
    columns: COMPANIES_COLUMNS,
  })

  const columns = [
    {
      title: 'Opportunity Attributes',
      elements: [
        companyColumnHelper.retrieveColumn('name'),
        companyColumnHelper.retrieveColumn('domain'),
        companyColumnHelper.retrieveColumn('address'),
        companyColumnHelper.retrieveColumn('city'),
        companyColumnHelper.retrieveColumn('state'),
        companyColumnHelper.retrieveColumn('zipcode'),
        companyColumnHelper.retrieveColumn('country'),
        companyColumnHelper.retrieveColumn('created'),
        companyColumnHelper.retrieveColumn('category'),
        companyColumnHelper.retrieveColumn('type'),
      ],
    },
    {
      title: 'Account Details',
      elements: [...getCommonChainProxyExportColumns()],
    },
  ]

  return (
    <ExportModal
      title={`Select Columns for Unmatched ${props.subCategoryName} Download`}
      subTitle="Download up to 10,000 opportunities at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Companies"
      columns={columns}
      overrideDataTypeName={props.subCategoryName}
      {...props}
    />
  )
}
